import {
  AutocompleteGroupInterface,
  AutocompleteOptionInterface,
  AutocompleteControlInterface,
} from '../components/autocomplete/interfaces';

import { BaseControl } from './base-control';

export class AutocompleteControl extends BaseControl {
  public options: AutocompleteOptionInterface[];
  public grouped: boolean;
  public groups: AutocompleteGroupInterface[];
  public checkForEmptyInputReference: (() => boolean) | undefined;
  public visibleGroupName: boolean;

  constructor(data: AutocompleteControlInterface) {
    super(data);

    this.options = data.options ?? [];
    this.grouped = data.grouped ?? false;
    this.groups = (data.groups as AutocompleteGroupInterface[]) ?? [];
    this.checkForEmptyInputReference = data.checkForEmptyInputReference;
    this.visibleGroupName = data.visibleGroupName ?? false;
  }

  setOptions(options: AutocompleteOptionInterface[]): void {
    this.options = options;
  }
}
